// InviteCollabbayCreator.js
import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  Image,
  TouchableOpacity,
  ScrollView,
  Alert,
  StyleSheet,
  ActivityIndicator,
  Modal
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Calendar } from 'react-native-calendars';
import { Linking } from 'react-native';
import { useRoute } from '@react-navigation/native';
import { Dimensions } from 'react-native';

const screenWidth = Dimensions.get('window').width;
const imageSize = Math.max(120, Math.min(screenWidth * 0.2, 240));



import { useNavigation } from '@react-navigation/native';

const InviteCollabbayCreator = () => {
  const navigation = useNavigation();

  const route = useRoute();
  const { Username } = route.params;
  

  const [creator, setCreator] = useState(null);
  const [offers, setOffers] = useState([]);
  const [selectedListingID, setSelectedListingID] = useState('');
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('1:00 PM');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [successModalVisible, setSuccessModalVisible] = useState(false);


  const [addedVisitors, setAddedVisitors] = useState('0');

  const [infoModalVisible, setInfoModalVisible] = useState(false);

  useEffect(() => {
    const fetchCreator = async () => {
      try {
        const res = await fetch(`https://collabbayadmin.com/APIControllers/ShowPromoterProfile.php?Promoter=${Username}`);
        const data = await res.json();
        setCreator(data[0]);
      } catch (err) {
        console.error(err);
      }
    };
    const fetchOffers = async () => {
      try {
        const res = await fetch('https://collabbayadmin.com/APIControllers/RetrieveBrandListings.php', {
          credentials: 'include'
        });
        const data = await res.json();
    
        // ✅ Filter only listings with PauseLiveToggle === 'Live'
        const liveOffers = data.filter(offer => offer.PauseLiveToggle === 'Live');
    
        setOffers(liveOffers);
      } catch (err) {
        console.error(err);
      }
    };
    

    fetchCreator();
    fetchOffers();
    setLoading(false);
  }, [Username]);

  const calculateAge = dob => {
    if (!dob) return 'N/A';
    const birth = new Date(dob);
    const now = new Date();
    let age = now.getFullYear() - birth.getFullYear();
    const m = now.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) age--;
    return age;
  };

  const handleOfferSubmit = async () => {
    if (!selectedOffer || !selectedDate || !selectedTime) return alert('Fill all fields');
    setIsSubmitting(true);



    const formattedDate = `${selectedDate} ${selectedTime}`;


    
    const payload = {
      Promoter: Username,
      ListingID: selectedOffer.ListingID,
      CreditAvailableStart: formattedDate,
      AddedVisitors: addedVisitors,
    };
    

    try {
      const res = await fetch('https://collabbayadmin.com/APIControllers/InsertVenueCollabSubmission.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload)
      });
      const result = await res.json();
      if (result.success) {
        setSuccessModalVisible(true);
        setTimeout(() => {
          Linking.openURL('https://collabbayadmin.com');
        }, 1500);
      }
       else {
        alert(result.error || 'Submission failed');
      }
    } catch (err) {
      console.error(err);
      alert('Submission failed');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading || !creator) {
    return (
      <View style={styles.loading}><ActivityIndicator size="large" color="black" /></View>
    );
  }



  return (
<ScrollView style={{ backgroundColor: '#fff' }} contentContainerStyle={{ paddingTop: 60, paddingHorizontal: 16, maxWidth: 600, alignSelf: 'center', width: '90%' }}>
      <TouchableOpacity onPress={() => navigation.goBack()} style={styles.backButton}>
  <Ionicons name="arrow-back" size={24} color="black" />
</TouchableOpacity>
      <View style={styles.profileCardLarge}>
        <View style={styles.profileRowModern}>
          <View style={styles.leftColumnModern}>
          <Image
  source={{ uri: creator.ProfileImage }}
  style={{
    width: imageSize,
    height: imageSize,
    borderRadius: imageSize / 2,
    borderColor: '#ccc',
    borderWidth: 2,
  }}
/>
            <Text style={styles.username}>{creator.PlatformUsername}</Text>
          </View>
          <View style={styles.rightColumnModern}>
          <Text style={styles.bioText}><Ionicons name="people-outline" size={16} /> {creator.PlatformFollowers} Followers</Text>
            <Text style={styles.bioText}><Ionicons name="information-circle-outline" size={16} /> {creator.ContentCategories} Creator</Text>
            <Text style={styles.bioText}><Ionicons name="calendar-outline" size={16} /> Age: {calculateAge(creator.DOB)}</Text>
            <TouchableOpacity style={styles.profileLink} onPress={() => Linking.openURL(`https://instagram.com/${creator.PlatformUsername}`)}>
              <Text style={styles.linkText}> View Instagram Profile</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>

      <TouchableOpacity onPress={() => setModalVisible(true)} style={styles.openModalBtn}>
        <Text style={styles.modalBtnText}>📦 Tap here to select an offer to propose</Text>
      </TouchableOpacity>

      {selectedOffer && (
        <View style={styles.offerCard}>
          <Text style={styles.selectedTitle}>Selected Offer</Text>
          <Text style={styles.offerText}>{selectedOffer.NonCreditOffer}</Text>
          <Text style={styles.offerValue}>Value: £{selectedOffer.Credits}</Text>
        </View>
      )}

      <Text style={styles.expandHeader}>📅 Choose a day to invite the creator</Text>
      <View style={{ marginVertical: 10 }}>
        <Calendar
          onDayPress={day => setSelectedDate(day.dateString)}
          markedDates={{ [selectedDate]: { selected: true, selectedColor: '#FDF05D' } }}
          theme={{ todayTextColor: '#FDF05D', selectedDayTextColor: '#000' }}
        />
       <ScrollView horizontal showsHorizontalScrollIndicator={true}>
    {Array.from({ length: 24 }, (_, i) => {
      const hour = Math.floor(i / 2) + 10;
      const minute = i % 2 === 0 ? '00' : '30';
      const ampm = hour >= 12 ? 'PM' : 'AM';
      const adjustedHour = hour > 12 ? hour - 12 : hour;
      const time = `${adjustedHour}:${minute} ${ampm}`;
      return (
        <TouchableOpacity
          key={i}
          style={[styles.timeOption, selectedTime === time && styles.timeSelected]}
          onPress={() => setSelectedTime(time)}
        >
          <Text>{time}</Text>
        </TouchableOpacity>
      );
    })}
  </ScrollView>
      </View>

      

      <View style={{ marginTop: 24 }}>
  <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
    <Text style={{ fontWeight: 'bold', fontSize: 16 }}>Allow the creator to bring guests</Text>
    <TouchableOpacity onPress={() => setInfoModalVisible(true)}>
      <Ionicons name="information-circle-outline" size={22} color="#888" />
    </TouchableOpacity>
  </View>

  <Text style={{ fontSize: 13, color: '#666', marginBottom: 10 }}>Allowing at least 1 plus-one for the creator is recommended. 
  {'\n'}Choose how many extra friends this creator can bring.</Text>

  <ScrollView horizontal showsHorizontalScrollIndicator={false} style={{ flexDirection: 'row' }}>
    {[
      { label: 'Just the creator', value: '0' },
      { label: '+1', value: '1' },
      { label: '+2', value: '2' },
      { label: '+3', value: '3' },
      { label: '+4', value: '4' },
    ].map(option => (
      <TouchableOpacity
        key={option.value}
        onPress={() => setAddedVisitors(option.value)}
        style={[
          styles.guestOptionBtn,
          addedVisitors === option.value && styles.guestOptionSelected,
        ]}
      >
        <Text style={{ fontWeight: 'bold', color: '#000' }}>{option.label}</Text>
      </TouchableOpacity>
    ))}
  </ScrollView>
</View>


      <TouchableOpacity
        style={[styles.submitBtn, isSubmitting && { opacity: 0.5 }]}
        onPress={handleOfferSubmit}
        disabled={isSubmitting}
      >
        <Text style={styles.modalBtnText}>{isSubmitting ? 'Submitting...' : 'Propose an Invite'}</Text>
      </TouchableOpacity>
      <Modal visible={modalVisible} animationType="slide">
  <View style={styles.modalView}>
    <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
      <Text style={styles.modalHeader}>Choose an Offer</Text>
      <TouchableOpacity onPress={() => setModalVisible(false)}>
        <Ionicons name="close" size={28} color="#333" />
      </TouchableOpacity>
    </View>
    <ScrollView>
      {offers.map((offer, i) => (
        <TouchableOpacity
          key={i}
          style={[
            styles.modalOfferCard,
            selectedListingID === offer.ListingID && styles.modalOfferCardSelected,
          ]}
          onPress={() => {
            setSelectedListingID(offer.ListingID);
            setSelectedOffer(offer);
            setModalVisible(false);
          }}
        >
          <Text>{offer.NonCreditOffer}</Text>
        </TouchableOpacity>
      ))}
    </ScrollView>
  </View>
</Modal>



      <Modal
  visible={infoModalVisible}
  transparent
  animationType="fade"
  onRequestClose={() => setInfoModalVisible(false)}
>
  <View style={styles.modalBackdrop}>
    <View style={styles.infoModalContent}>
      <Ionicons name="information-circle-outline" size={32} color="#fdf05d" />
      <Text style={styles.infoText}>
  Allowing creators to bring guests can help them feel more comfortable and increase their likelihood of attending.{'\n'}
  The most common party size is 2, the creator and a plus-one. Only the influencer will be due to deliver your content in exchange for the offer.
</Text>
      <TouchableOpacity
        style={styles.dismissButton}
        onPress={() => setInfoModalVisible(false)}
      >
        <Text style={styles.dismissButtonText}>Got it</Text>
      </TouchableOpacity>
    </View>
  </View>
</Modal>


      <Modal visible={successModalVisible} transparent>
        <View style={styles.successOverlay}>
          <View style={styles.successModalBox}>
            <Ionicons name="checkmark-circle-outline" size={48} color="green" />
            <Text style={styles.successText}>Request sent. You'll be notified if the creator accepts.</Text>
            <TouchableOpacity style={styles.submitBtn} onPress={() => setSuccessModalVisible(false)}>
              <Text style={styles.modalBtnText}>OK</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  loading: { flex: 1, justifyContent: 'center', alignItems: 'center' },
  profileCardLarge: { backgroundColor: '#f9f9f9', padding: 20, borderRadius: 27, marginBottom: 20 },
  profileRowModern: { flexDirection: 'row', alignItems: 'center' },
  leftColumnModern: { alignItems: 'center', width: '40%' },
  rightColumnModern: { width: '60%', justifyContent: 'center', paddingLeft: 40 },
  largeCircularImage: {
    width: imageSize,
    height: imageSize,
    borderRadius: imageSize / 2,
    borderColor: '#ccc',
    borderWidth: 2,
  },  
  username: { marginTop: 10, fontSize: 15, fontWeight: 'bold', color: '#000' },
  bioText: { fontSize: 17, color: '#333', marginBottom: 6, fontWeight: 'bold' },
  profileLink: { flexDirection: 'row', alignItems: 'center', backgroundColor: '#fdf05d', padding: 8, borderRadius: 8, marginTop: 6, alignSelf: 'flex-start' },
  linkText: { fontWeight: 'bold', fontSize: 13 },
  openModalBtn: { backgroundColor: '#fdf05d', padding: 12, borderRadius: 10, marginVertical: 10 },
  modalBtnText: { fontWeight: 'bold', textAlign: 'center' },
  offerCard: { backgroundColor: '#f3f3f3', borderRadius: 14, padding: 14, marginVertical: 10 },
  selectedTitle: { fontWeight: 'bold', fontSize: 16 },
  offerText: { marginTop: 6 },
  offerValue: { marginTop: 4, fontWeight: '600' },
  expandHeader: { fontSize: 16, fontWeight: 'bold', marginTop: 16, color: '#333' },
  timeOption: { padding: 10, margin: 6, backgroundColor: '#eee', borderRadius: 10 },
  timeSelected: { backgroundColor: '#fdf05d' },
  submitBtn: { backgroundColor: '#fdf05d', padding: 14, borderRadius: 10, marginTop: 20 },
  modalView: { padding: 20, flex: 1 },
  modalHeader: { fontWeight: 'bold', fontSize: 18, marginBottom: 10 },
  modalOfferCard: { padding: 14, marginVertical: 6, backgroundColor: '#eee', borderRadius: 10 },
  modalOfferCardSelected: { backgroundColor: '#fdf05d' },
  successOverlay: { flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.4)' },
  successModalBox: { backgroundColor: '#fff', padding: 20, borderRadius: 16, width: '80%', alignItems: 'center' },
  successText: { fontSize: 16, marginVertical: 10, textAlign: 'center' },
  backButton: {
    position: 'absolute',
    top: 20,
    left: 16,
    zIndex: 10,
    padding: 8,
    borderRadius: 30,
  },guestOptionBtn: {
    paddingVertical: 10,
    paddingHorizontal: 16,
    backgroundColor: '#eee',
    borderRadius: 10,
    marginRight: 10,
    marginBottom: 10,
  },
  guestOptionSelected: {
    backgroundColor: '#fdf05d',
  },
  modalBackdrop: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  infoModalContent: {
    backgroundColor: '#fff',
    padding: 24,
    borderRadius: 20,
    width: '80%',
    maxWidth: 400,
    alignItems: 'center',
  },
  infoText: {
    fontSize: 15,
    textAlign: 'center',
    color: '#333',
    marginTop: 12,
    marginBottom: 20,
  },
  dismissButton: {
    backgroundColor: '#fdf05d',
    paddingVertical: 10,
    paddingHorizontal: 24,
    borderRadius: 10,
  },
  dismissButtonText: {
    fontWeight: 'bold',
    color: '#000',
  },
  
  
});

export default InviteCollabbayCreator;
